import {HttpError} from 'react-admin';
import {isAxiosError} from 'axios';

function axiosMessageAndBody(error: import('axios').AxiosError): {
    message: string;
    body: unknown;
} {
    const data = error.response?.data;
    if (data && typeof data === 'object' && 'message' in data) {
        const msg = (data as {message: unknown}).message;
        if (typeof msg === 'string' && msg.length > 0) {
            return {message: msg, body: data};
        }
    }
    return {message: error.message, body: data ?? null};
}

/**
 * Maps Axios failures to {@link HttpError} so react-admin sees `error.status`
 * (e.g. for `checkError`, notifications, and access-denied handling).
 */
export function rethrowAsHttpError(error: unknown): never {
    if (error instanceof HttpError) {
        throw error;
    }
    if (isAxiosError(error)) {
        const status = error.response?.status ?? 503;
        const {message, body} = axiosMessageAndBody(error);
        throw new HttpError(message, status, body);
    }
    throw error;
}

/** Runs `fn` and maps Axios rejections to {@link HttpError}. */
export async function withHttpError<T>(fn: () => Promise<T>): Promise<T> {
    try {
        return await fn();
    } catch (e) {
        rethrowAsHttpError(e);
    }
}
